import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import PageSection from '../components/PageSection/PageSection';

interface IKeyTakeawaysSection {
  keyTakeaways: string;
}

const KeyTakeawaysSection: FC<IKeyTakeawaysSection> = ({ keyTakeaways }) => {
  const { t } = useTranslation();

  return (
    <PageSection ariaLabel="summary">
      <PageSection.Header>
        <PageSection.Header.Title tag="h3" title={t('results.report.keyTakeaways.title')} />
      </PageSection.Header>
      <PageSection.Content>
        <div dangerouslySetInnerHTML={{ __html: keyTakeaways }} />
      </PageSection.Content>
    </PageSection>
  );
};

export default KeyTakeawaysSection;
